import { render, staticRenderFns } from "./modalProduto.component.html?vue&type=template&id=1efebc2b&scoped=true&"
import script from "./ModalProduto.vue?vue&type=script&lang=ts&"
export * from "./ModalProduto.vue?vue&type=script&lang=ts&"
import style0 from "./modalProduto.component.scss?vue&type=style&index=0&id=1efebc2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efebc2b",
  null
  
)

export default component.exports